import { render, staticRenderFns } from "./download-uploaded-document.vue?vue&type=template&id=b65bfa9a&scoped=true"
import script from "./download-uploaded-document.vue?vue&type=script&lang=js"
export * from "./download-uploaded-document.vue?vue&type=script&lang=js"
import style0 from "./download-uploaded-document.vue?vue&type=style&index=0&id=b65bfa9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65bfa9a",
  null
  
)

export default component.exports